module.exports = __webpack_public_path__ + "img/model5_zh.3f303383.jpg";